export const PRODUCTS = [
  {
    id: "collagen-bar",
    name: "DNA Collagen Bar",
    flavor: "Cranberry Bliss",
    tagline: "Nourish. Renew. Radiate.",
    formulaName: "Triple Thrive Formula",
    price: 115,
    protein: "10g",
    ingredients: [
      { name: "Collagen", dose: "100mg" },
      { name: "L-Glutamine", dose: "250mg" },
      { name: "Ashwagandha", dose: "50mg" },
    ],
    image: "/images/product-collagen-bar.jpeg",
    accent: "#2E0C1A",
    chapter: "01",
    description:
      "Tart cranberries folded into a rich, fudgy base with collagen builders and 10g clean, zero-bloat protein — Beauty, fed from within.",
  },
  {
    id: "creatine-bar",
    name: "DNA Creatine Bar",
    flavor: "Choco Almond",
    tagline: "Rich. Nutty. Built Different.",
    formulaName: "Triple Threat Formula",
    price: 115,
    protein: "10g",
    ingredients: [
      { name: "Creatine", dose: "3g" },
      { name: "Ashwagandha", dose: "50mg" },
      { name: "L-Glutamine", dose: "250mg" },
    ],
    nutrition: {
      serving: "Per Serve — 40g Bar",
      rows: [
        ["Energy", "185.2 kcal"],
        ["Protein", "10g"],
        ["Total Carbohydrate", "16g"],
        ["of which Sugars", "4.636g", true],
        ["of which Added Sugars", "0g", true],
        ["of which Natural Sugars", "4.636g", true],
        ["Dietary Fiber", "2.392g"],
        ["Total Fat", "9.04g"],
        ["Saturated Fat", "1.668g", true],
        ["Polyunsaturated Fat", "2.28g", true],
        ["Monounsaturated Fat", "4.468g", true],
        ["Trans Fat", "0g"],
        ["Sodium", "96.4mg"],
        ["Cholesterol", "0mg"],
      ],
      actives: [
        ["Creatine", "3g"],
        ["Ashwagandha", "50mg"],
        ["L-Glutamine", "250mg"],
      ],
      ingredients:
        "Date Paste, Cashews, Pea Protein, Whey Protein Concentrate, Almonds, Cocoa Powder, Cocoa Butter, Ashwagandha, Glutamine, Creatine.",
    },
    image: "/images/product-creatine-bar.jpeg",
    accent: "#0B1221",
    chapter: "02",
    description:
      "Rich cocoa and crunchy roasted almonds paired with 10g clean, zero-bloat protein. Infused with targeted performance compounds to fuel your daily physical and mental hustle.",
  },
];

export const INGREDIENT_NOTES = {
  Collagen: "The structural protein of skin, hair and joints. Radiance, fed from within.",
  Creatine: "The most researched performance molecule on earth. Strength, power, output.",
  "L-Glutamine": "The recovery amino. Repairs muscle and gut lining while you rest.",
  Ashwagandha: "Ayurveda's adaptogen, backed by modern trials. Calm inside the chaos.",
};

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
